import { useMutation, useQueryClient } from "@tanstack/react-query";
import { applicationService } from "@/services/application.service";

export function useRedoApplication() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => applicationService().redoApplication(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["applications", "list"] });
			queryClient.invalidateQueries({ queryKey: ["studyMaterials"] });
			queryClient.invalidateQueries({ queryKey: ["applicationExecution"] });
		},
	});
}
